







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'PrineButton',
    components: {},
})
export default class PrineButton extends Vue {
    @Prop({ required: false, default: false }) private disabled: boolean;
    @Prop({ required: false, default: 'button' }) private langKey: string;
    @Prop({ required: false, default: '' }) private icon: string;
    @Prop({ required: false, default: false }) private loading: boolean;
    @Prop({ required: false, default: 'is-primary' }) private customClass: string;

    public confirm() {
        this.$emit('toggleConfirmModal', true);
    }
}
